import 'node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import 'node_modules/cssuseragent/cssua.js';
import 'node_modules/slick-carousel/slick/slick.js';
import '../node_modules/jquery-match-height/jquery.matchHeight';
import anime from '../node_modules/animejs/lib/anime.es.js';
import 'pivot-base.js';

jQuery( document ).ready( function( $ ) {

  // Hamburgers
  const hamburgerIcon = $(".hamburger");
  hamburgerIcon.on("click", function(e) {
    hamburgerIcon.toggleClass("is-active");
    $("nav, body").toggleClass("is-open");
  });

  // Logo sticky
  if ( $('body').hasClass('home')) {
    const stickyLogo = $('#pd-main-nav-logo').offset().top;
    $(window).on('scroll', function(e) {
      if ($(window).scrollTop() > stickyLogo) {
        $('#pd-main-nav-logo').addClass('is-sticky');
      }
    });
  } else {
    $('#pd-main-nav-logo').addClass('is-sticky');
  }

  // Move nav address
  function navAppend() {
    // if ($(window).width() > 768) {
      $('.pd-nav-address').appendTo('#pd-menu-main_menu');
    // }
  }

  // Show modal on page load
  // function directionsModal() {
  //   $(window).on('load', function(e) {
  //     $('#directionsModal').modal('show');
  //   });
  //
  //   $('#directionsModal').on('show.bs.modal', function (e) {
  //       setTimeout(function(){
  //         $('.modal-backdrop').addClass('is-custom');
  //       });
  //   });
  //
  //   $('#directionsModal').on('hidden.bs.modal', function (e) {
  //     $('.modal-backdrop').removeClass('is-custom');
  //   });
  //
  //   // Hide prompts after time
  //   setTimeout(function() {
  //     $('#directionsModal').modal('hide');
  //   }, 4000);
  //   setTimeout(function() {
  //     $('body.home .wp-block-page-header:first-of-type > .container > .img-container').addClass('fade-indicator');
  //   }, 4000);
  // }

  // if ($(window).width() > 1199) {
  //   directionsModal();
  // }

  // Let's debounce our heavy lifts // https://css-tricks.com/snippets/jquery/done-resizing-event/
  var resizeTimer;
  navAppend();

  $(window).on('resize', function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Run code here, resizing has "stopped"
      navAppend();
    }, 250);
  });

  // Slick Slider
  $('.pd-image-slider').slick({
    arrows: false,
    dots: true,
    prevArrow: '<a class="carousel-control-prev" role="button"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
    nextArrow: '<a class="carousel-control-next" role="button"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: false
  });

  $('.pd-team-modals').on('show.bs.modal', function (e) {
    let personIndex = $(e.relatedTarget).data('index');
    $('.pd-modal-list').slick({
      // lazyLoad: 'ondemand',
      arrows: true,
      dots: false,
      prevArrow: '<a class="carousel-control-prev" role="button"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="text-primary pd-arrow-text">Previous</span></a>',
      nextArrow: '<a class="carousel-control-next" role="button"><span class="text-primary pd-arrow-text">Next</span><span class="carousel-control-next-icon" aria-hidden="true"></span></a>',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      adaptiveHeight: false,
      centerMode: true,
      initialSlide: personIndex,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            fade: true,
          }
        }
      ]
    });
  });


  // Video autoplay
  // $('.pd-video-modal').on('shown.bs.modal', function () {
  //   $('video')[0].play();
  // })
  // $('.pd-video-modal').on('hidden.bs.modal', function () {
  //   $('video')[0].pause();
  // })

  // Video Data tag
  function autoPlayYouTubeModal(){
    var trigger = $("body").find('[data-toggle="modal"]');
    trigger.click(function() {
      var theModal = $(this).data( "target" ),
      videoSRC = $(this).attr( "data-theVideo" ),
      videoSRCauto = videoSRC+"?autoplay=1" ;
      $(theModal+' iframe').attr('src', videoSRCauto);
      $(theModal+' button.close').click(function () {
        $(theModal+' iframe').attr('src', videoSRC);
      });
    });
  }

  $('.modal').on('hidden.bs.modal', function (e) {
    $('.modal .close').trigger('click')
  });

  autoPlayYouTubeModal();

  // jQuery matchHeight
  $('.card-img-overlay').matchHeight();
  $('.wp-block-image-cards .img-container').matchHeight({
    target: $('.wp-block-image-cards .card-img-overlay')
  });

  // Add spans to nav items for clean underlines
  $('.pd-main-menu-wrap .navbar-nav .nav-link, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a, .h1 a, .h2 a, .h3 a, .h4 a, .h5 a, .h6 a').wrapInner('<span></span>');

  // Move view all to end of list
  document.addEventListener('facetwp-loaded', function() {
    $(".facetwp-type-radio .facetwp-radio:first").appendTo(".facetwp-type-radio");
    $('.facetwp-radio').wrapInner('<span></span>');
  });

  if ( $('.post-type-archive-pd_person').length ) {
    //https://www.bennadel.com/blog/3460-automatically-scroll-the-window-when-the-user-approaches-the-viewport-edge-in-javascript.htm

    var desktop = null;
    if ( $(window).width() > 1199 ) {
      desktop = true;
    }

    $('.pd-team-modals').on('shown.bs.modal', function (e) {
      $('.pd-modal-list').slick('setPosition');
      $('.pd-modal-display').addClass('is-loaded');
      if (desktop) {
        window.removeEventListener( "mousemove", handleMousemove, false ); // remove scroll behavior
      }
    });

    $('.pd-team-modals').on('hidden.bs.modal', function (e) {
      $('.pd-modal-list').slick('unslick');
      $('.pd-modal-display').removeClass('is-loaded');
      if (desktop) {
        window.addEventListener( "mousemove", handleMousemove, false ); // re-add scroll behavior
      }
    });

    var edgeSize = 250;
    var timer = null;

    if (desktop) {
      window.addEventListener( "mousemove", handleMousemove, false );
    }
  }

});
